<template>
  <v-layout row wrap justify-center align-center>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <v-layout row wrap align-end>
          <v-flex>
            <h1> Central de evidências </h1>
            <v-spacer></v-spacer>
          </v-flex>
          <v-flex>
            <v-icon class="pesquisaIcon" 
              size='30px'
              @click="dialogFiltro = true">search</v-icon>
          </v-flex>
          </v-layout>

        </v-card-title>
        <v-layout align-center justify-center row fill-height>
          <v-progress-circular
            indeterminate
            align-center
            :size="50"
            style="text-align: center"
            color="primary"
            v-if="waiting"
          ></v-progress-circular>
        </v-layout>
        <v-container fluid class="mx-0 px-0">
          <div class="my-cards">
            <fade-transition
              :duration="600"
              v-for="evidencia in evidencias.results"
              :key="evidencia.id"
            >
              <evidencia
                class="mb-2"
                v-if="evidencia.author === $store.state.user.username || 
                      evidencia.status === 'P' || evidencia.status === 'F' || 
                      showEvidencia"
                style="display: inline-block; width:100%;"
                :image="getUserImage(evidencia.author)"
                :evidencia="evidencia"
                :avaliavel="true"
                moreopts="true"
                @changed="mudouEvidencia"
                @exclui="retirarevid"
                @avaliar="abrirAvaliacao(evidencia)"
              />
            </fade-transition>
          </div>
        </v-container>
        <v-flex xs12 justify-center class="text-xs-center">
          <v-pagination :length="evidencias.pages" total-visible="7" circle v-model="page"></v-pagination>      
        </v-flex>
      </v-card>
              

        <!-- dialog de deletar projeto-->
        <v-dialog v-model="dialogDel" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Deseja deletar?</v-card-title>
            <v-card-text>Gostaria excluir esse projeto com suas solicitacoes e atividades ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click.native="dialogDel = false">Cancelar</v-btn>
              <v-btn color="green darken-1" flat @click.native="excluir()">Deletar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar
        v-model="snackbar"
        bottom
        color="success">
        {{ text }}
          <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
        </v-snackbar>

        <!-- dialog de deletar solicitacao -->
        <v-dialog v-model="delTaf" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Deseja deletar?</v-card-title>
            <v-card-text>Gostaria excluir essa solicitação ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click.native="delTaf = false">Cancelar</v-btn>
              <v-btn color="green darken-1" flat @click.native="excluirTaf()">Deletar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- dialog de deletar atividade -->
        <v-dialog v-model="delAtividade" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Deseja deletar?</v-card-title>
            <v-card-text>Gostaria excluir essa atividade ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click.native="delAtividade = false">Cancelar</v-btn>
              <v-btn color="green darken-1" flat @click.native="excluirAtividade()">Deletar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar
        v-model="snackbar"
        bottom
        color="success">
        {{ text }}
          <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
        </v-snackbar>


        <!-- Dialog do editar  atividade-->

        <v-dialog id="dialog" v-model="dialogAtividade" max-width="100%">
        <v-card>
          <v-card-title> 
            <h1>Editar Atividade</h1>

            <v-icon
              size="25"
              @click="delAtividade = true"
              style="position: absolute; top: 8px; right: 16px" 
            >
              delete
            </v-icon> 
          </v-card-title>
          <v-card-text>
            <v-text-field 
              label="Titulo da atividade" 
              ref="obs"
              hint="Exemplo: Aula 1"
              v-model="atividadeTitulo"></v-text-field>
            <v-text-field 
              label="Descrição da atividade" 
              hint="Descreva o que necessita para realização da atividade"
              v-model="atividadeDescricao"></v-text-field>
              <v-text-field 
              label="Objetivo da atividade" 
              hint="Descreva o objetivo da atividade"
              v-model="atividadeObjetivo"></v-text-field>
            </v-card-text>
          <v-card-actions>
            <input-criterios-aval 
              style="width: 100%"
              :criterios="criterios"
              :titulo="titulo"
              :clear="clear"
              :btnedit="btnedit"
              :editHabil="editHabil"
              @saved="criteriosSelecionados"
              @edit="editAtividade"
            >
            </input-criterios-aval>
          </v-card-actions>
        </v-card>
      </v-dialog>


        <!-- Dialog do editar  Solicitação-->

        <v-dialog id="dialog" v-model="dialog" max-width="100%">
        <v-card>
          <v-card-title> 
            <h1>Editar Solicitação</h1>

            <v-icon
              size="25"
              @click="delTaf = true"
              style="position: absolute; top: 8px; right: 16px" 
            >
              delete
            </v-icon> 
          </v-card-title>
          <v-card-text>
            <v-text-field 
              label="Titulo da atividade" 
              ref="obs"
              hint="Exemplo: Aula 1"
              v-model="tarefatitulo"></v-text-field>
            <v-text-field 
              label="Descrição da atividade" 
              hint="Descreva o que necessita para realização da atividade"
              v-model="tarefadescricao"></v-text-field>
            </v-card-text>
          <v-card-actions>
            <input-criterios-aval 
              style="width: 100%"
              :criterios="criterios"
              :titulo="titulo"
              :clear="clear"
              :btnedit="btnedit"
              :editHabil="editHabil"
              @saved="criteriosSelecionados"
              @edit="editAtual"
            >
            </input-criterios-aval>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- DIALOG FILTRO -->
      <v-dialog id="dialog" v-model="dialogFiltro" max-width="50%">
        <v-card>
          <v-card-title>
            <h1 style="margin-left: auto; margin-right: auto">Escolha o projeto</h1>
          </v-card-title>
          <v-card-text>
            <v-row wrap>
                <!-- <v-autocomplete
                  :items="$store.state.listproj"
                  v-model="projectid"
                  label="Selecione um projeto"
                  item-text="name"
                  item-value="id"
                  chips
                  item-avatar="3"
                  max-height="auto"
                  style="width: 94%"
                > 
                  <template v-slot:selection="data">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.name"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="$store.state.badge[projectid]"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete> -->

              <v-autocomplete
                v-model="projectid"
                :items="$store.state.listproj"
                box
                color="blue-grey lighten-2"
                label="Select"
                item-text="name"
                item-value="name"
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
                <span>
                  <b>Evidências foco: </b>{{$store.state.badge[projectid]}}
                </span>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="dialogFiltro = false">Cancelar</v-btn>
            <v-btn color="green darken-1" flat @click.native="filtrar()">Filtrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import api from '@/api';
import ProfileText from '@/components/reusable/ProfileText.vue';
import Evidencia from '@/components/reusable/evidencia.vue';
import AvalDialogContent from '@/components/reusable/AvalDialogContent.vue';
import ChangeImage from '@/components/reusable/ChangeImage.vue';
import { FadeTransition } from 'vue2-transitions';
import InputCriteriosAval from '@/components/reusable/inputCriteriosAval.vue';
import ShowCriterio from '@/components/reusable/showCriterio.vue';
import StatusComponent from '@/components/reusable/StatusComponent.vue';
export default {
  components: {
    ProfileText,
    AvalDialogContent,
    Evidencia,
    ChangeImage,
    FadeTransition,
    InputCriteriosAval,
    ShowCriterio,
    StatusComponent
  },
  data () {
    return {
      currentTab: 'Sobre',
      showImageUpload: false,
      imageChangeModal: false,
      projetoData: [],
      editing: false,
      delTaf: false,
      delAtividade: false,
      dialogDel: false,
      dialog: false,
      evid_avaliada: {},
      dialog_criterios: false,
      dialogAtividade: false,
      btnDialog: false,
      snackbar: false,
      text: 'Evidência excluída',
      tempData: {},
      options: {},
      solicitacao: false,
      botaosaved: false,
      evidencias: {},
      atividades: [],
      solicitacoes: [],
      criterios: [],
      avaliacoes: [],
      tarefatitulo: '',
      titulo: true,
      btnedit: false,
      dialogFiltro: false,
      clear: true,
      tarefadescricao: '',
      atividadeTitulo: '',
      atividadeDescricao: '',
      atividadeObjetivo: '',
      onerror: '',
      src: '',
      salvandoCriterio: [],
      refresh: true,
      editHabil: [],
      projectid: '',
      search: '',
      selected: [],
      lista: [],
      criteriosSelecionados: [],
      waiting: true,
      alunos: [],
      listamediador: [],
      page: 1,
      alunos_ids_old: {
        pausa: [],
        progresso: [],
        concluido: []
      },
      alunos_ids: {
        pausa: [],
        progresso: [],
        concluido: []
      }
    };
  },
  mounted () {
    if (this.$store.state.central !== 0) {
      this.projectid = this.$store.state.central
      this.getEvidenciaLab()
      this.init()
    } else {
      this.waiting = false
      this.dialogFiltro = true
    }
    this.$watch('projetoData.moderador', function () {
      this.getStudents(this.projetoData.moderador);
    })
    this.$watch('evidencias', function () {
      // this.refreshUI()
    });
    console.log('store', this.$store.state)
  },
  watch: {
    page (val, oldVal) {
      this.getEvidencia(val);
    }
  },
  computed: {
    getIntegrantes () {
      var progresso = [];
      var pausa = [];
      var concluido = [];
      progresso = this.projetoData.integrantes.filter(
        obj => obj.status === 'Em Progresso'
      );
      pausa = this.projetoData.integrantes.filter(
        obj => obj.status === 'Em Pausa'
      );
      concluido = this.projetoData.integrantes.filter(
        obj => obj.status === 'Finalizado'
      );
      this.alunos_ids_old.progresso = progresso.map(item => item.id);
      this.alunos_ids_old.pausa = pausa.map(item => item.id);
      this.alunos_ids_old.concluido = concluido.map(item => item.id);
      return [pausa, progresso, concluido];
    },

    safeImage () {
      if (
        this.projetoData.image === '' ||
        this.projetoData.image === undefined
      ) {
        return 'https://firebasestorage.googleapis.com/v0/b/mundomaker-staging.appspot.com/o/images%2Fdefault-user-image.png?alt=media';
      } else {
        return this.projetoData.image;
      }
    },
    permissao () {
      if (this.$store.state.user.is_superuser) {
        return true
      } else {
        return this.$store.state.details.can_delete_project
      }
    },
    showEvidencia () {
      if (this.$store.state.user.is_superuser) {
        return true
      }
      if (this.$store.state.selectedRole.name === 'Mediador') {
        if (this.projetoData.moderador === this.$store.state.user.username) {
          return true
        } else {
          return false
        }
      }
      if (this.$store.state.selectedRole.name !== 'Aluno') {
        return true
      }
    }
  },
  methods: {
    init () {
      this.getEvidenciaLab()
      api.request('GET', 'projetos/' + this.projectid + '/').then(response => {
        this.projetoData = response.data;
        console.log('username', this.projetoData.moderador)
        this.getStudents(this.projetoData.moderador);
        this.getMediador()
        this.getCriterios()
      })
      this.getAtividades()

      api.request('GET', 'tarefas/?projeto__id=' + this.projectid).then(resp => {
        this.solicitacoes = resp.data
        console.log(resp.data)
      })
    },
    filtrar () {
      this.init()
      this.dialogFiltro = false
    },
    abrirAvaliacao (evidencia) {
      this.evid_avaliada = evidencia;
      // this.avaliando = true
      this.$store.commit('SET_EVID', evidencia);
      this.$router.push('/projetos/' + evidencia.id + '/avaliacao');
    },
    criaAvaliacoes () {
      this.dialog_criterios = false;
      let avaliacoes = [];
      this.selected.forEach(val => {});
      this.avaliacoes = avaliacoes;
    },
    goToUnidade (unidade) {
      this.$router.push('/unidade/' + unidade);
    },
    imageError () {
      this.onerror = null
      this.$refs.logo.src = this.projetoData.image
    },
    integrantesChange (change) {
      console.log('changed integrantes');
      console.log(change);
      var progresso = [];
      var pausa = [];
      var concluido = [];
      progresso = change[1];
      pausa = change[0];
      concluido = change[2];
      this.alunos_ids.progresso = progresso.map(item => item.id);
      this.alunos_ids.pausa = pausa.map(item => item.id);
      this.alunos_ids.concluido = concluido.map(item => item.id);
      var diffpausa = this.alunos_ids.pausa.filter(
        x => !this.alunos_ids_old.pausa.includes(x)
      );
      var diffprogresso = this.alunos_ids.progresso.filter(
        x => !this.alunos_ids_old.progresso.includes(x)
      );
      var diffconcluido = this.alunos_ids.concluido.filter(
        x => !this.alunos_ids_old.concluido.includes(x)
      );
      var alunosArray = [];
      var status = '';
      if (diffpausa.length > 0) {
        status = 'P';
        alunosArray = diffpausa;
      } else if (diffprogresso.length > 0) {
        status = 'A';
        alunosArray = diffprogresso;
      } else {
        status = 'F';
        alunosArray = diffconcluido;
      }
      api.request('POST', 'projetos-change-status/', {
        projeto: this.projectid,
        alunos: alunosArray,
        status: status
      });
      console.log('here');
      console.log(change);
      console.log('pausa: ', diffpausa);
      console.log('progresso: ', diffprogresso);
      console.log('concluido: ', diffconcluido);
    },
    getAtividades () {
      api.request('GET', 'atividade/?projeto__id=' + this.projectid).then(resp => {
        this.atividades = resp.data
        this.$store.commit('SET_ATIVIDADES', resp.data)
      })
    },
    getCriterios () {
      api.request('GET', 'criterioavaliacao/').then(response => {
        this.criterios = response.data;
      });
    },
    excluir () {
      api
        .request('DELETE', 'projetos/' + this.$route.params.id + '/')
        .then(resp => {
          if (this.solicitacoes.length === 0) {
            if (this.atividades.length === 0) {
              this.$router.push('/projetos')
            }
          }
          if (this.atividades.length !== 0) {
            for (let index = 0; index < this.atividades.length; index++) {
              console.log('atividade', this.atividades[index].id)
              api
              .request('DELETE', 'atividade/' + this.atividades[index].id + '/')
              .then(response => {
                if (this.solicitacoes.length === 0) {
                  this.$router.push('/projetos')
                }
              })
            }
          }
          if (this.solicitacoes.length !== 0) {
            for (let index = 0; index < this.solicitacoes.length; index++) {
              console.log('solicitacao', this.solicitacoes[index].id)
              api.request('DELETE', 'tarefas/' + this.solicitacoes[index].id + '/').then(response => {
                this.$router.push('/projetos')
              })
            }
          }
        })
    },
    getUserImage (username) {
      var userarray = this.projetoData.integrantes.filter(value => {
        return value.username === username;
      });
      if (userarray[0]) {
        return userarray[0].profilePic;
      } else {
        return '';
      }
    },
    getUser (username) {
      var userarray = this.projetoData.integrantes.filter(value => {
        return value.username === username;
      });
      return userarray[0];
    },
    getEvidencia (page = 1) {
      api
        .request(
          'GET',
          'evidencias/?page=' + page + '&is_focus_evidence=true&is_not_evaluated=true'
        )
        .then(response => {
          this.evidencias = response.data;
          console.log('evid', response.data);
          this.waiting = false;
        });
    },
    getEvidenciaLab (page = 1) {
      api
        .request(
          'GET',
          'evidencias/?page=' + page + '&project=' + this.projectid + '&is_focus_evidence=true&is_not_evaluated=true'
        )
        .then(response => {
          this.evidencias = response.data;
          console.log('evid', response.data);
          this.waiting = false;
        });
    },
    mudouEvidencia (evidencia) {
      // console.log('evidencia', evidencia)
      var ind;
      var found = this.evidencias.results.some((evid, index) => {
        ind = index;
        return evidencia.id === evid.id;
      });
      if (!found) {
        // console.log('Erro');
        return false;
      }
      this.evidencias.results.splice(ind, 1, evidencia);
      // console.log(ind)
    },
    pressFloatingButton () {
      if (this.editing) {
        this.performSave();
      } else {
        this.editing = !this.editing;
      }
    },
    performSave () {
      var projectid = this.$route.params.id;
      var nomes = this.projetoData.integrantes_pks.map(user => {
        return user;
      });
      let self = this;
      api
        .request('PATCH', 'projetos/' + projectid + '/', {
          description: self.projetoData.description,
          name: self.projetoData.name, // vai editar nome?
          justificativa: self.projetoData.justificativa,
          recursos: self.projetoData.recursos,
          objetivo: self.projetoData.objetivo,
          moderador: self.projetoData.moderador,
          integrantes_pks: nomes
        })
        .then(function (response) {
          self.refreshUI();
          // console.log(response);
        });
      self.editing = false;
    },
    retirarevid (retirar) {
      var posic;
      var busca = this.evidencias.results.some((evid, index) => {
        posic = index;
        return retirar === evid.id;
      });
      if (!busca) {
        // console.log('Erro');
        return false;
      }
      this.evidencias.results.splice(posic, 1);
      this.snackbar = true;
    },
    imageProject (image) {
      var path = 'projetos/' + this.$route.params.id + '/';

      var name =
        'images/projetos/' +
        'projectPic_' +
        this.$route.params.id +
        '.jpg&' +
        new Date().getTime();

      var upload = this.fbstorage.child(name).putString(image, 'data_url');

      upload.on(
        'state_changed',
        snapshot => console.log(snapshot),
        error => console.log(error),
        url => {
          console.log(upload.snapshot);
          var payload = {
            image: name
          };
          api.request('PATCH', path, payload).then(resp => {
            // console.log(resp.data)
            this.imageChangeModal = false;
            this.refreshUI();
          });
        }
      );
    },
    getStudents (mediador) {
      api
        .request('GET', 'search-user?mediador__username=' + mediador)
        .then(response => {
          this.alunos = response.data;
        });
    },
    getMediador () {
      api.request('GET', 'search-user?groups__name=Mediador').then(resp => {
        this.listamediador = resp.data;
      });
    },
    oneError () {
      alert('uiah')
    },
    refreshUI () {
      this.refresh = false;
      var projectid = this.$route.params.id;
      api.request('GET', 'projetos/' + projectid + '/').then(response => {
        this.refresh = false;
        this.projetoData = response.data;
        this.getEvidencia();
        this.refresh = true;
      });
      api.request('GET', 'tarefas/?projeto__id=' + projectid).then(resp => {
        this.refresh = false;
        this.atividades = resp.data;
        this.refresh = true;
      });
      this.refresh = false;
      this.getAtividades()
      this.refresh = true;
    },
    editar (value, index) {
      console.log(value, index)
      this.editHabil = value
      this.tarefatitulo = value.title
      this.tarefadescricao = value.description
      this.ident = index
      console.log(index)
      this.btnedit = true
      this.dialog = true
    },
    editarAtividade (value, index) {
      console.log(value, index)
      this.editHabil = value
      this.atividadeTitulo = value.title
      this.atividadeDescricao = value.description
      this.atividadeObjetivo = value.objetivo
      this.ident = index
      this.btnedit = true
      this.dialogAtividade = true
    },
    excluirTaf () {
      api.request('DELETE', 'tarefas/' + this.editHabil.id + '/').then(response => {
        this.delTaf = false
        this.dialog = false
        this.refreshUI()
      })
    },
    excluirAtividade () {
      api.request('DELETE', 'atividade/' + this.editHabil.id + '/').then(response => {
        this.delAtividade = false
        this.dialogAtividade = false
        this.refreshUI()
      })
    },
    editAtual (value) {
      console.log(value)
      for (let index = 0; index < value.length; index++) {
        this.lista[index] = value[index].id
      }
      console.log(this.lista)

      this.salvandoCriterio = {
        'title': this.tarefatitulo,
        'description': this.tarefadescricao,
        'evidencia_foco': true,
        'habilidades_pks': this.lista
      }
      api.request('PATCH', 'tarefas/' + this.editHabil.id + '/', this.salvandoCriterio).then(response => {
        console.log(response)
        this.tarefatitulo = ''
        this.tarefadescricao = ''
        this.tarefaData = ''
        this.editHabil = []
        this.lista = []

        this.refreshUI()
      })

      this.dialog = false
    },
    editAtividade (value) {
      console.log(value)
      for (let index = 0; index < value.length; index++) {
        this.lista[index] = value[index].id
      }
      console.log(this.lista)

      this.salvandoCriterio = {
        'title': this.atividadeTitulo,
        'description': this.atividadeDescricao,
        'objetivo': this.atividadeObjetivo,
        'habilidades_pks': this.lista
      }
      api.request('PATCH', 'atividade/' + this.editHabil.id + '/', this.salvandoCriterio).then(response => {
        console.log(response)
        this.atividadeTitulo = ''
        this.atividadeDescricao = ''
        this.atividadeObjetivo = ''
        this.editHabil = []
        this.lista = []

        this.refreshUI()
      })

      this.dialogAtividade = false
    }
  }
};
</script>

<style lang="scss" scoped>
.video-player {
  width: 100%;
}
.image-edit {
  margin-right: -20px;
  margin-bottom: 15px;
}
.smaller-tabs {
  .tabs__div {
    font-size: 0.9rem;
  }
}

.rounded-corner {
  border-radius: 10px;
}

/* CSS do player */

.vjs-custom-skin > .video-js {
  width: 100%;
  font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI",
    "Microsoft YaHei", "微软雅黑", sans-serif;
}

.vjs-custom-skin > .video-js .vjs-menu-button-inline.vjs-slider-active,
.vjs-custom-skin > .video-js .vjs-menu-button-inline:focus,
.vjs-custom-skin > .video-js .vjs-menu-button-inline:hover,
.video-js.vjs-no-flex .vjs-menu-button-inline {
  width: 10em;
}

.vjs-custom-skin > .video-js .vjs-controls-disabled .vjs-big-play-button {
  display: none !important;
}

.vjs-custom-skin > .video-js .vjs-control {
  width: 3em;
}

.vjs-custom-skin > .video-js .vjs-control.vjs-live-control {
  width: auto;
  padding-left: 0.5em;
  letter-spacing: 0.1em;
}

.vjs-custom-skin > .video-js .vjs-menu-button-inline:before {
  width: 1.5em;
}

.vjs-menu-button-inline .vjs-menu {
  left: 3em;
}

.vjs-paused.vjs-has-started.vjs-custom-skin > .video-js .vjs-big-play-button,
.video-js.vjs-ended .vjs-big-play-button,
.video-js.vjs-paused .vjs-big-play-button {
  display: block;
}

.vjs-custom-skin > .video-js .vjs-load-progress div,
.vjs-seeking .vjs-big-play-button,
.vjs-waiting .vjs-big-play-button {
  display: none !important;
}

.vjs-custom-skin > .video-js .vjs-mouse-display:after,
.vjs-custom-skin > .video-js .vjs-play-progress:after {
  padding: 0 0.4em 0.3em;
}

.video-js.vjs-ended .vjs-loading-spinner {
  display: none;
}

.video-js.vjs-ended .vjs-big-play-button {
  display: block !important;
}

.video-js.vjs-ended .vjs-big-play-button,
.video-js.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started.vjs-custom-skin > .video-js .vjs-big-play-button {
  display: block;
}

.vjs-custom-skin > .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-left: -1.5em;
  margin-top: -1em;
}

.vjs-custom-skin > .video-js .vjs-big-play-button {
  background-color: rgba(0, 0, 0, 0.45);
  font-size: 3.5em;
  /*border-radius: 50%;*/
  height: 2em !important;
  line-height: 2em !important;
  margin-top: -1em !important;
}

.video-js:hover .vjs-big-play-button,
.vjs-custom-skin > .video-js .vjs-big-play-button:focus,
.vjs-custom-skin > .video-js .vjs-big-play-button:active {
  background-color: rgba(36, 131, 213, 0.9);
}

.vjs-custom-skin > .video-js .vjs-loading-spinner {
  border-color: rgba(36, 131, 213, 0.8);
}

.vjs-custom-skin > .video-js .vjs-control-bar2 {
  background-color: #000000;
}

.vjs-custom-skin > .video-js .vjs-control-bar {
  /*background-color: rgba(0,0,0,0.3) !important;*/
  color: #ffffff;
  font-size: 14px;
}

.vjs-custom-skin > .video-js .vjs-play-progress,
.vjs-custom-skin > .video-js .vjs-volume-level {
  background-color: #2483d5;
}

.vjs-custom-skin > .video-js .vjs-play-progress:before {
  top: -0.3em;
}

.vjs-custom-skin > .video-js .vjs-progress-control:hover .vjs-progress-holder {
  font-size: 1.3em;
}

.vjs-menu-button-popup.vjs-volume-menu-button-vertical .vjs-menu {
  left: 0em;
}

.vjs-custom-skin > .video-js .vjs-menu li {
  padding: 0;
  line-height: 2em;
  font-size: 1.1em;
  font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI",
    "Microsoft YaHei", "微软雅黑", sans-serif;
}

.vjs-custom-skin > .video-js .vjs-time-tooltip,
.vjs-custom-skin > .video-js .vjs-mouse-display:after,
.vjs-custom-skin > .video-js .vjs-play-progress:after {
  border-radius: 0;
  font-size: 1em;
  padding: 0;
  width: 3em;
  height: 1.5em;
  line-height: 1.5em;
  top: -3em;
}

.vjs-custom-skin > .video-js .vjs-menu-button-popup .vjs-menu {
  width: 5em;
  left: -1em;
}

.vjs-custom-skin
  > .video-js
  .vjs-menu-button-popup.vjs-volume-menu-button-vertical
  .vjs-menu {
  left: 0;
}

// .vjs-custom-skin > .video-js .vjs-control-bar .vjs-resolution-button .vjs-menu {
//   /*order: 4;*/
// }

/*排序顺序*/
.vjs-custom-skin > .video-js .vjs-control-bar .vjs-play-control {
  order: 0;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-time-control {
  min-width: 1em;
  padding: 0;
  margin: 0 0.1em;
  text-align: center;
  display: block;
  order: 1;
}

.vjs-custom-skin
  > .video-js
  .vjs-control-bar
  .vjs-playback-rate
  .vjs-playback-rate-value {
  font-size: 1.2em;
  line-height: 2.4;
}

.vjs-custom-skin > .video-js .vjs-progress-control.vjs-control {
  order: 2;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-volume-menu-button {
  order: 3;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-resolution-button {
  order: 4;
}

.vjs-custom-skin
  > .video-js
  .vjs-control-bar
  .vjs-resolution-button
  .vjs-resolution-button-label {
  display: block;
  line-height: 3em;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-playback-rate {
  order: 5;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-fullscreen-control {
  order: 6;
}

.my-cards {
  column-count: 2;
  column-gap: 1em;
}

.redondo {
  width: 2.7rem;
  height: 2.7rem;
  color: #fff;
  background-color: white;
  border: 1px black solid;
  margin-left: 0px;
  border-radius: 50%;
}
.image-edit {
  margin-right: -20px;
  margin-bottom: 15px;
}
.pesquisaIcon{
  position:absolute;
  right: 15px;
  top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AlertCentral.vue